import React, { Component } from 'react';
import ActiveRules from './active-rules/ActiveRules';
import TurnedOffRules from './turned-off-rules/TurnedOffRules';
import { connect } from 'react-redux';
import { fetchRules } from './redux/actions';
import {
    getCanUpdateRules,
    getHoldsRulesForSomeBrandsOnly,
    getSelectedJurisdictionCode,
    isSandboxSelected
} from '../../../jurisdiction/redux/selectors';
import { PageActionsRow } from '../../../shared/headers/PageActionsRow';
import { BackButton } from '../../../shared/button/back-button/BackButton';
import { ReadOnlyNote } from '../../../shared/read-only-note/ReadOnlyNote';
import { SandboxNote } from '../../../shared/sandbox/SandboxNote';
import { getRuleCategoryFromLocation } from '../../../services/RuleCategory';

class ModifyRulesContainer extends Component {
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (
            this.props.jurisdictionCode !== prevProps.jurisdictionCode ||
            this.props.ruleCategory !== prevProps.ruleCategory
        ) {
            this.fetchRules();
        }
    }

    componentDidMount() {
        this.fetchRules();
    }

    fetchRules() {
        const { fetchRules, ruleCategory, jurisdictionCode } = this.props;
        fetchRules &&
            ruleCategory &&
            jurisdictionCode &&
            fetchRules(ruleCategory, jurisdictionCode);
    }

    renderRules() {
        const {
            ruleCategory,
            canUpdate,
            someBrandsOnly,
            jurisdictionCode,
            sandboxSelected
        } = this.props;

        return (
            <div>
                {sandboxSelected && (
                    <SandboxNote>
                        {`${jurisdictionCode} is a sandbox. Its rules are a copy: a change here affects only this sandbox, not the jurisdiction it was copied from.`}
                    </SandboxNote>
                )}
                {!canUpdate && (
                    <ReadOnlyNote>
                        {someBrandsOnly
                            ? `Your teams have the permission to change these rules for only some of the brands of ${jurisdictionCode}. The rules of a jurisdiction apply to all its brands, so it takes the permission for every one of them: ask whoever manages your teams.`
                            : "You don't have permission to change these rules."}
                    </ReadOnlyNote>
                )}
                <ActiveRules
                    ruleCategory={ruleCategory}
                    readOnly={!canUpdate}
                />
                <TurnedOffRules
                    ruleCategory={ruleCategory}
                    readOnly={!canUpdate}
                />
            </div>
        );
    }

    render() {
        const { ruleCategory, loaded, jurisdictionCode } = this.props;

        return (
            <div className="container">
                <PageActionsRow>
                    <BackButton />
                </PageActionsRow>

                {!ruleCategory ? (
                    // The address was opened directly and names no category (see getRuleCategoryFromLocation)
                    <div className={'no-jurisdiction'}>
                        Open Modify Rules from the alerts of a category.
                    </div>
                ) : jurisdictionCode ? (
                    loaded && this.renderRules()
                ) : (
                    <div className={'no-jurisdiction'}>
                        Please choose a jurisdiction to adjust weights.
                    </div>
                )}
            </div>
        );
    }
}

const mapStateToProps = (state, { location }) => {
    const { loaded } = state.rules;
    const jurisdictionCode = getSelectedJurisdictionCode(state);
    const ruleCategory = getRuleCategoryFromLocation(location);

    return {
        jurisdictionCode,
        ruleCategory,
        canUpdate: getCanUpdateRules(state, ruleCategory),
        someBrandsOnly: getHoldsRulesForSomeBrandsOnly(state, ruleCategory),
        sandboxSelected: isSandboxSelected(state),
        loaded
    };
};

const mapDispatchToProps = dispatch => ({
    fetchRules: (ruleCategory, jurisdiction) =>
        dispatch(fetchRules({ ruleCategory, jurisdiction }))
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ModifyRulesContainer);
